import { TranslatedTerms } from "../../globals/TranslatedTerms";
import { DefaultId } from "../../shared/Globals";
import { TranslationDictionary } from "../../shared/Language";


export const PropertyDictionary: TranslationDictionary = {
    [TranslatedTerms.ADDRESS]: {
        [DefaultId]: "Address",
        "da": "Adresse"
    },
    [TranslatedTerms.ZIP_AND_CITY]: {
        [DefaultId]: "Zip and city",
        "da": "Postnr og by"
    },
    [TranslatedTerms.PHONE]: {
        [DefaultId]: "Phone",
        "da": "Telefon"
    },
    [TranslatedTerms.COMPNAY_ID]: {
        [DefaultId]: "Compnay id",
        "da": "CVR Nummer"
    },
    [TranslatedTerms.FIRST_NAME]: {
        [DefaultId]: "First name",
        "da": "Fornavn"
    },
    [TranslatedTerms.LAST_NAME]: {
        [DefaultId]: "Last name",
        "da": "Efternavn"
    },
    [TranslatedTerms.EMAIL_ADDRESS]: {
        [DefaultId]: "Email address",
        "da": "Email adresse"
    },
    [TranslatedTerms.PASSPORT]: {
        [DefaultId]: "Passport",
        "da": "Pas"
    },
    [TranslatedTerms.IDENTIFICATION]: {
        [DefaultId]: "Identification",
        "da": "Identifikation"
    },
    [TranslatedTerms.COUNTRY]: {
        [DefaultId]: "Country",
        "da": "Land"
    },
    [TranslatedTerms.LANGUAGE]: {
        [DefaultId]: "Language",
        "da": "Sprog"
    },
    [TranslatedTerms.PASSWORD]: {
        [DefaultId]: "Password",
        "da": "Password"
    },
    [TranslatedTerms.CAPITAL_SOURCE_DESCRIPTION]: {
        [DefaultId]: "Where does the capital you want to lend come from?",
        "da": "Hvorfra kommer kapitalen du vil udlåne?"
    },
    [TranslatedTerms.SALARY_PENSION]: {
        [DefaultId]: "Salary/pension",
        "da": "Løn/pension"
    },
    [TranslatedTerms.PENSION]: {
        [DefaultId]: "Pension",
        "da": "Pension"
    },
    [TranslatedTerms.SAVINGS]: {
        [DefaultId]: "Savings",
        "da": "Opsparing"
    },
    [TranslatedTerms.HERITAGE_GIFT]: {
        [DefaultId]: "Heritage/gift",
        "da": "Arv/gave"
    },
    [TranslatedTerms.LOTTERY]: {
        [DefaultId]: "Lottery/games",
        "da": "Lotteri/spil"
    },
    [TranslatedTerms.INTREST_REVENUE]: {
        [DefaultId]: "Interests/revenue",
        "da": "Renter/udbytte"
    },
    [TranslatedTerms.PAID_BACK]: {
        [DefaultId]: "Paid back",
        "da": "Tilbagebetalt"
    },
    [TranslatedTerms.OTHER]: {
        [DefaultId]: "Other",
        "da": "Andet"
    },
    [TranslatedTerms.NAME]: {
        [DefaultId]: "Name",
        "da": "Navn"
    },
    [TranslatedTerms.PROVIDE_YOUR_ACCOUNT_NAME]: {
        [DefaultId]: "Company name or account owner full mame",
        "da": "Firma navn eller konto ejerens fulde navn"
    },
    [TranslatedTerms._LESS_THAN_100_000_DKK]: {
        [DefaultId]: "< 100.000 DKK",
        "da": "< 100.000 DKK"
    },
    [TranslatedTerms._100_000_TO_750_000_DKK]: {
        [DefaultId]: "100.000 DKK - 750.000 DKK",
        "da": "100.000 DKK - 750.000 DKK"
    },
    [TranslatedTerms._750_000_TO_2_000_000_DKK]: {
        [DefaultId]: "750.000 DKK - 2.000.000 DKK",
        "da": "750.000 DKK - 2.000.000 DKK"
    },
    [TranslatedTerms._MORE_THAN_2_000_000_DKK]: {
        [DefaultId]: "> 2.000.000 DKK",
        "da": "> 2.000.000 DKK"
    },
    [TranslatedTerms.HOW_MUCH_DO_YOU_PLAN_ON_LENDING_OUT]: {
        [DefaultId]: "How much do you totally plan on lending out?",
        "da": "Hvor meget planlægger du at udlåne samlet?"
    },
    [TranslatedTerms.WHY_WILL_YOU_RENT_OUT_CAPITAL]: {
        [DefaultId]: "Why will you lend out your capital?",
        "da": "Hvorfor vil du gerne udlåne din formue?"
    },
    [TranslatedTerms.OPTIMIZE_CAPITAL_OR_PENSION]: {
        [DefaultId]: "Optimize savings / pension",
        "da": "Optimere opsparing / pension"
    },
    [TranslatedTerms.AS_GIFT_TO_RELATIVE]: {
        [DefaultId]: "As a gift to a relative",
        "da": "Som gave til nærtstående part"
    },
    [TranslatedTerms.ALTERNATIVE_TO_DONATIONS]: {
        [DefaultId]: "Alternative to donations",
        "da": "Alternativ til velgørenhed"
    },
    [TranslatedTerms.TRADING]: {
        [DefaultId]: "Trading",
        "da": "Trading"
    },
    [TranslatedTerms.IDENTIFICATION_DESCRIPTION]: {
        [DefaultId]: "National id or insurance card",
        "da": "Sundhedskort/sygesikringsbevis"
    },
    [TranslatedTerms.COMPANY_PASSPORT]: {
        [DefaultId]: "Owners passport or drivers license",
        "da": "Ejers pas eller kørekort"
    },
    [TranslatedTerms.COMPANY_PASSPORT_DESCRIPTION]: {
        [DefaultId]: "Passport or drivers license from all owners",
        "da": "Pas eller kørekort fra alle ejere"
    },
    [TranslatedTerms.REGISTER_OF_OWNERS]: {
        [DefaultId]: "Register of owners",
        "da": "Ejerbog"
    },
    [TranslatedTerms.REGISTER_OF_OWNERS_DESCRIPTION]: {
        [DefaultId]: "Updated and signed by all owners",
        "da": "Opdateret og signeret af alle ejere"
    },
    [TranslatedTerms.COMPANY_IDENTIFICATION]: {
        [DefaultId]: "Owners identification",
        "da": "Ejers sundhedskort/sygesikringsbevis"
    },
    [TranslatedTerms.COMPANY_IDENTIFICATION_DESCRIPTION]: {
        [DefaultId]: "National id or health insurance card from all owners",
        "da": "Alle ejers sundhedskort/sygesikringsbevis"
    },
    [TranslatedTerms.INSTRUMENT_OF_INCORPORATION]: {
        [DefaultId]: "Instrument of incorporation",
        "da": "Stiftelsesdokument"
    },
    [TranslatedTerms.INSTRUMENT_OF_INCORPORATION_DESCRIPTION]: {
        [DefaultId]: "Upload latest instrument of incorporation",
        "da": "Upload seneste stiftelsesdokument"
    },
    [TranslatedTerms.BANK_ACCOUNT_DESCRIPTION]: {
        [DefaultId]: "Please provide your bank IBAN number",
        "da": "Venligst angiv bank konto- og reg nummer/IBAN nummer"
    },
    [TranslatedTerms.SOCIAL_SECURITY_NUMBER]: {
        [DefaultId]: "Social security number",
        "da": "CPR Nummer"
    },
    "reference-fb-person": {
        [DefaultId]: "I know a Fundbricks representative",
        "da": "Jeg kender en Fundbricks repræsentant"
    },
    "reference-facebook": {
        [DefaultId]: "Facebook ads/group",
        "da": "Facebook reklame/gruppe"
    },
    "reference-google": {
        [DefaultId]: "Google search",
        "da": "Google søgning"
    },
    "reference-friend-family": {
        [DefaultId]: "Network/familie",
        "da": "Netværk/familie"
    },
    "reference-other": {
        [DefaultId]: "Other",
        "da": "Andet"
    },
    "reference-linkedin": {
        [DefaultId]: "Linkedin"
    },
    "reference-printed-media": {
        [DefaultId]: "Printed media",
        "da": "Trykte medier"
    },
    "reference-mit-osterbro": {
        [DefaultId]: "Mit Østerbro"
    },
    "reference-villa-byerne": {
        [DefaultId]: "Villabyerne"
    },
    [TranslatedTerms.CVR_OR_COMANY_REGISTRATION]: {
        [DefaultId]: "Company registration number",
        "da": "CVR Nummer"
    },
    [TranslatedTerms.PEP_LIST_MEMBER]: {
        [DefaultId]: "Are you a politically exposed person or are you closely associated with one?",
        "da": "Er du en politisk eksponeret person eller har du nær tilknytning til en sådan?"
    }
}